import { AssetsToLoad, SpineAsset } from '@scarybeasties/phaser-framework-core/modules';
import { SceneId } from './app-routing';
import { Sounds } from './sounds';

import assetPackPreloadGeneric from '../../static/asset-packs/asset-pack-preload-generic.json';
import assetPackCommon from '../../static/asset-packs/asset-pack-common.json';
import assetPackTitle from '../../static/asset-packs/asset-pack-title.json';
import assetPackIntro from '../../static/asset-packs/asset-pack-intro.json';
import assetPackLevelSelect from '../../static/asset-packs/asset-pack-level-select.json';
import assetPackGame from '../../static/asset-packs/asset-pack-game.json';
import assetPackCharacterSelect from '../../static/asset-packs/asset-pack-character-select.json';
// import assetPackGame32 from '../../static/asset-packs/asset-pack-game-32.json';

export const AssetPack = {
  PreloadGeneric: 'asset-pack-preload-generic',
  Common: 'asset-pack-common',
  Title: 'asset-pack-title',
  Game: 'asset-pack-game',
  // Game32: 'asset-pack-game-32',
  LevelSelect: 'asset-pack-level-select',
  CharacterSelect: 'asset-pack-character-select'
} as const;

export const SpineAssets = {
  // Add spine animation names here!
	Taz: 'taz',
  TitleFireworks: 'titleFireworks',
} as const;

// Placeholder.
export const audioLookup: Set<string> = new Set();

export const assetPackLookup: Map<string, any> = new Map([
  [AssetPack.PreloadGeneric, assetPackPreloadGeneric as any],

  [AssetPack.Common, assetPackCommon],
  [AssetPack.Title, assetPackTitle],
  [AssetPack.Game, assetPackGame],
  // [AssetPack.Game32, assetPackGame32],
  [AssetPack.LevelSelect, assetPackLevelSelect],
  [AssetPack.CharacterSelect, assetPackCharacterSelect]
]);

// Contains functions that return the assets to load at different bit.

export const assetsToPreload = (scene: Phaser.Scene, preloaderId: keyof typeof SceneId) => {
  switch (preloaderId) {
    case SceneId.PreloadGeneric:
      scene.load.pack('pack', assetPackPreloadGeneric as any);
      break;

    default:
      break;
  }
};

export const assetsToLoad = (scene: Phaser.Scene) => {
  scene.load.pack('asset-pack-common', assetPackCommon as any);
  scene.load.pack('asset-pack-title', assetPackTitle as any);
  // scene.load.pack('asset-pack-game', assetPackGame as any);
  // scene.load.pack('asset-pack-game-32', assetPackGame32 as any);
  // scene.load.pack('asset-pack-level-select', assetPackLevelSelect as any);
  // scene.load.pack('asset-pack-character-select', assetPackCharacterSelect as any);

  // Load all sounds defined in Sounds.Track
  audioToLoad(scene, scene.app.Config.audioBasePath, scene.app.Config.audioFileFormats, Object.values(Sounds.Track));
};

export const buildSpineLookup = (assetPath: string): Map<string, SpineAsset> => {
  const spineAssets: SpineAsset[] = [
	  { key: SpineAssets.Taz,jsonURL: 'taz-spin.json', atlasURL: 'taz-spin.atlas', preMultipliedAlpha: true },
    { key: SpineAssets.TitleFireworks,jsonURL: 'title-fireworks.json', atlasURL: 'title-fireworks.atlas', preMultipliedAlpha: true }
  ];

  const spineAssetLookup: Map<string, SpineAsset> = new Map();

  // Inject full asset path and any missing values.
  for (const spineAsset of spineAssets) {
    if (spineAsset.jsonURL) spineAsset.jsonURL = assetPath + spineAsset.jsonURL;
    else spineAsset.jsonURL = assetPath + spineAsset.key + '.json';

    if (spineAsset.atlasURL) spineAsset.atlasURL = assetPath + spineAsset.atlasURL;
    else spineAsset.atlasURL = assetPath + spineAsset.key + '.atlas';

    spineAssetLookup.set(spineAsset.key, spineAsset);
  }
	
	console.log(spineAssetLookup);

  return spineAssetLookup;
};

export const dynamicGameSceneAssetsToLoad = (scene: Phaser.Scene): AssetsToLoad => {
  let dynamicAssets: AssetsToLoad = {
    assetPacks: [],
    spines: [SpineAssets.Taz],
    audio: []
  };

  return dynamicAssets;
};

export const addAllFormats = (fileName: string, path: string, fileFormats: string[]): [string, string[]] => {
  let output: string[] = [];
  for (const extension of fileFormats) output.push(`${path}${fileName}.${extension}`);
  return [fileName, output];
};

/**
 * Load all sounds passed in the soundsToLoad array in four formats, .webm, .m4a, .ogg., and .mp3.
 *
 * @param scene - The scene to use for loading.
 * @param soundsToLoad - Array of sounds to load.
 */
export const audioToLoad = (scene: Phaser.Scene, assetPath: string, fileFormats: string[], soundsToLoad: string[]) => {
  for (const sound of soundsToLoad) {
    scene.load.audio(...addAllFormats(sound, assetPath, fileFormats));
  }
};
